import axiosInstance from "../axiosClient";
import {
  userCreation,
  userList,
  userUpdate,
  deleteUserUri,
  restoreUserUri,
} from "../config";



export const getUsers = async (name,limit, start_key ,email ,id) => {
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`)
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (email) queryParams.push(`email=${encodeURIComponent(email)}`)
  if (id) queryParams.push(`id=${encodeURIComponent(id)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.get(`${userList}${queryString}`);
};

export const createUser = async (data) => {
  return await axiosInstance.post(userCreation,data);
};

export const update_User=  async(data) => {
  return await axiosInstance.patch(userUpdate,data);
};

// Activate (restore) or deactivate (soft-delete) a user.
// Backend: POST admin/restore_user {id} / POST admin/delete_user {id}.
export const handleuserStatus = async ({ id, activate }) => {
  const uri = activate ? restoreUserUri : deleteUserUri;
  return await axiosInstance.post(uri, { id });
};



